var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    focusable: "false",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "arrow-back_svg__a",
    d: "M15.023 1.037a1.5 1.5 0 01.037 2.083L5.628 12.5H38a1.5 1.5 0 010 3H5.62l9.44 9.44a1.49 1.49 0 010 2.12 1.51 1.51 0 01-1.06.44 1.51 1.51 0 01-1.06-.44l-12-12-.047-.048a1.5 1.5 0 01.33-2.295L12.94 1a1.5 1.5 0 012.083.037z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "arrow-back_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrow-back_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#arrow-back_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M-4-10h48v48H-4z",
    mask: "url(#arrow-back_svg__b)"
  }))));
}

export default __webpack_public_path__ + "ondemand/static/e3056e037/icons/arrow-back.svg";
export { SvgArrowBack as ReactComponent };